<template>
	<div class="g-flex g-row-center">
		<div class="g-m-30 container total-width">
			<div class="g-p-30">
				<el-tabs v-model="tabNow">
					<el-tab-pane label="找回密码" name="0"></el-tab-pane>
				</el-tabs>

				<div class="g-m-t-10 forms">
					<div class="g-flex g-nowrap g-text-left g-m-t-20">
						<p class="label g-font-18">手机号</p>
						<el-input v-model="phone" class="g-m-l-52 inputs" type="number" placeholder="请输入手机号"></el-input>
					</div>
					<div class="g-flex g-nowrap g-text-left g-m-t-20">
						<p class="label g-font-18">验证码</p>
						<el-input v-model="code" class="g-m-l-52 code-inputs" type="number" placeholder="请输入验证码">
						</el-input>
						<div class="submit-btn code-btn" @click="sendTextCode(phone)">
							{{ send ? times + 's后重新发送' : '发送验证码' }}
						</div>
					</div>
					<div class="g-flex g-nowrap g-text-left g-m-t-20">
						<p class="label g-font-18">输入新密码</p>
						<el-input v-model="psw" class="g-m-l-52 inputs" type="password" placeholder="请输入新密码"></el-input>
					</div>
					<div class="g-flex g-nowrap g-text-left g-m-t-20">
						<p class="label g-font-18">确认新密码</p>
						<el-input v-model="rePsw" class="g-m-l-52 inputs" type="password" placeholder="请再次输入新密码">
						</el-input>
					</div>
					<div class="submit-btn submits" @click="submit">
						确认修改
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import sendCode from "@/mixins/sendCode";
	import md5 from 'js-md5'
	import {
		findPassword
	} from "@/api/user.js"
	export default {
		mixins: [sendCode],
		name: "found-psw",
		data() {
			return {
				tabNow: '0',
				phone: '',
				code: '',
				psw: '',
				rePsw: '',
				sence:'password'
			}
		},
		methods: {
			submit() {
				if (!this.phone) {
					return this.$message.error('请输入手机号！')
				}
				if (!this.code) {
					return this.$message.error('请输入验证码！')
				}
				if (!this.psw) {
					return this.$message.error('请输入密码！')
				}
				if (this.psw != this.rePsw) {
					return this.$message.error('两次输入的密码不一致')
				}
				if (this.psw.length < 6) {
					return this.$message.error('密码长度不小于6位字符！')
				}
				let obj = {
					mobile: this.phone,
					newPassword: this.psw,
					// newPassword: md5(this.psw),
					key: this.key,
					code: this.code
				}
				
				findPassword(obj, {}).then(res => {
					this.$message({message:'密码找回成功',duration:1000});
					setTimeout(()=>{
						this.$router.replace({name: 'login'})
					},1000)
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		background: #fff;
		border-radius: 5px;
	}

	::v-deep .el-tabs__item.is-active {
		color: #333;
		font-size: 20px;
		font-weight: 500;
	}

	.forms {
		margin-left: 120px;
	}

	.code-btn {
		margin-right: 0;
		padding: 10px 25px;
		margin-left: 20px;
	}

	.label {
		width: 120px;
	}

	.inputs {
		width: 280px;
	}

	.code-inputs {
		width: 140px;
	}

	::v-deep .el-input__inner {
		background-color: #f6f6f8;
		border-radius: 3px;
		border: none;
	}

	.submits {
		padding: 12px 33px;
		margin: 50px 0;
		display: inline-block;
	}
</style>
